import React from 'react'
import data from '../data/data.json'


const backend = () => {
const dataBackend = data.backend;
  return (
    <div className="skills__content">
    <h3 className="skills__title">
    Backend Developer
    </h3>
    <div className="skills_box">
        <div className="skills_group">
        {
        dataBackend.map(({name,level})=>{
            return(
                <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                <div>
                    <h3 className='skills_name'>{name}</h3>
                    <span className='skills__level'>{level}</span>
                </div>
            </div>
            )
          })
        } 
            {/* <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                <div>
                    <h3 className='skills_name'>PHP</h3>
                    <span className='skills__level'>Intermediate</span>
                </div>
            </div>
            <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                <div>
                    <h3 className='skills_name'>Node Js</h3>
                    <span className='skills__level'>Basic</span>
                </div>
            </div> */}
        </div>
        {/* <div className="skills_group">
            <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                <div>
                    <h3 className='skills_name'>MySQL</h3>
                    <span className='skills__level'>Intermediate</span>
                </div>
            </div>
            <div className="skills__data">
                <i className='bx bx-badge-check'></i>
                <div>
                    <h3 className='skills_name'>JAVA</h3>
                    <span className='skills__level'>Basic</span>
                </div>
            </div>
        </div> */}
    </div>
</div>
  )
}

export default backend